import styled, { css } from 'styled-components'

interface PropsWrapper {
  size: string;
}

export const Wrapper = styled.div<PropsWrapper>`
  position: relative;
  width: max-content;
  ${props => props.size === 'sm' && css`
    cursor: pointer;
  `}
`

interface PropsAvatar {
  size: string;
}

export const Avatar = styled.div<PropsAvatar>`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${props => props.theme};
  ${props => props.theme.sizes[props.size]};

  img{
    max-width: 100%;
  }
  ${props => props.size === 'sm' && css`
    ${props.theme.motion};
    &:hover{
      ${props.theme.states.hover}
    }
  `}
`

export const NotificationSpan = styled.span`
  display:block;
  position: absolute;
  ${props => props.theme.notification}
`

export const Brand = styled.span`
  position: absolute;
  right: -4px;
  bottom: -4px;
    svg{
      ${props => props.theme.brand}
    }
`